export const FILE_UPLOAD_STATUS = {
  QUEUED: "queued",
  UPLOADING: "uploading",
  UPLOADED: "uploaded",
};
